import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import About from '../pages/About';
import AdminLayout from '../layouts/AdminLayout';
import Tickets from '../pages/admin/Tickets';
import Valves from '../pages/admin/Valves';
import Users from '../pages/admin/Users';
import Login from '../pages/admin/Login';
import Test from '../pages/admin/QiniuTest';
import TencentMap from '../pages/admin/TencentMap';
import ValvesDetail from '../pages/admin/ValvesDetail';
import PipeMap from '../pages/admin/PipeMap';

const router = createBrowserRouter([
  {
    path: '/admin/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        path: 'qiniutest',
        element: <Test />
      },
      {
        path: 'tickets',
        element: <Tickets />
      },
      {
        path: 'valves',
        element: <Valves />
      },
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'tencentmap',
        element: <TencentMap />
      },
      {
        path: 'pipemap',
        element: <PipeMap />
      },
      {
        path: 'valves/:id',
        element: <ValvesDetail />
      }
    ]
  }
]);

export default router;